<div class="container">

    <div class="card-container sigle-page-card" *ngIf="!isLoadingResults">
        <div class="card-header-wrapper">
            <h2 class="card-title"> Definir password</h2>

            <br>
            <br>

        </div>

        <div *ngIf="isLinkExpirado">
            <div class="card-header-wrapper">
                <!--<h3 class="card-title"> Link expirado</h3>-->
                <span> </span>
            </div>

            <div class="card-component">
                <span>{{mensagemErro}}</span>
                <br>
                <br>

                <button kendoButton routerLink='/recoverpass' themeColor="primary">
                    Pedir novo link
                </button>


            </div>
        </div>

        <div class="card-component">

            <form class="k-form k-form-horizontal" style="max-width: 700px;width: 700px;" [formGroup]="formGroup">

                <fieldset class="k-form-fieldset">

                    <kendo-formfield orientation="horizontal">
                        <kendo-label [for]="password" text="Password"> </kendo-label>
                        <!-- <input class="k-textbox k-input k-input-md k-rounded-md k-input-solid" type="password" formControlName="password"#password required/> -->
                        <kendo-textbox formControlName="password" (keydown.enter)="$event.preventDefault()"
                            #password="kendoTextBox" required>
                            <ng-template kendoTextBoxSuffixTemplate>
                                <kendo-textbox-separator></kendo-textbox-separator>
                                <button kendoButton fillMode="flat" icon="eye" (keydown.enter)="$event.preventDefault()"
                                    (click)="selectedChange()"></button>
                            </ng-template>
                        </kendo-textbox>
                    </kendo-formfield>

                    <kendo-formfield orientation="horizontal">
                        <kendo-label [for]="passwordRewrite" text="Reescrever password"> </kendo-label>
                        <kendo-textbox formControlName="passwordRewrite" (keydown.enter)="$event.preventDefault()"
                            #passwordRewrite="kendoTextBox" required>
                            <ng-template kendoTextBoxSuffixTemplate>
                                <kendo-textbox-separator></kendo-textbox-separator>
                                <button kendoButton fillMode="flat" icon="eye" (keydown.enter)="$event.preventDefault()"
                                    (click)="selectedChangeRe()"></button>
                            </ng-template>
                        </kendo-textbox>
                        <kendo-formerror>Passwords don´t match</kendo-formerror>
                    </kendo-formfield>

                    <br />
                    <hr />
                    <br />

                    <button kendoButton (click)="onSubmit()" themeColor="primary">
                        Gravar
                    </button>

                </fieldset>
            </form>

        </div>

    </div>

    <div class="card-container sigle-page-card" *ngIf="isLoadingResults">
        <p style="color: #4dbd74;">A sua password foi definida com sucesso</p>
        <button kendoButton (click)="loginPage()" themeColor="primary">Ir para a página de login</button>

    </div>
</div>

<div kendoDialogContainer></div>